import React, { useState, useContext } from 'react';
import { LanguageContext } from "../LanguageContext";
import '../App.css';
import defaultphoto from '../default.png'
import audiophoto from '../audio.png'
import articlephoto from '../article.png'
import NeedsContentDisplay from './NeedsContentDisplay';
import ContentDisplay from './ContentDisplay';

// contentByPhoto: { photoId: { header, textBase, audio? } }
const PhotoGallery = ({ onImageClick, activePhoto: activeProp, onActiveChange }) => {
    const { t, setLanguage } = useContext(LanguageContext);

    const [internalActive, setInternalActive] = useState(null);

    const displayedActive = typeof activeProp !== 'undefined' && activeProp !== null ? activeProp : internalActive;

    const handleClick = (photoId) => {
        if (onImageClick) onImageClick(photoId);
        if (onActiveChange) {
            onActiveChange(displayedActive === photoId ? null : photoId);
        } else {
            setInternalActive((prev) => (prev === photoId ? null : photoId));
        }
    };

    // PhotoGallery now only renders the image grid. Panels should be rendered by the parent
    return (
        <div className="photo-gallery">
            <div className={`rectangle ${displayedActive === 'photo1' ? 'active' : ''}`} onClick={() => handleClick('photo1')}>
                <img src={articlephoto} alt="DF" />
                <div className="text">{t("needs_article1_title")}</div>
            </div>

            <div className={`rectangle ${displayedActive === 'photo2' ? 'active' : ''}`} onClick={() => handleClick('photo2')}>
                <img src={articlephoto} alt="HW" />
                <div className="text">{t("needs_article2_title")}</div>
            </div>

            <div className={`rectangle ${displayedActive === 'photo3' ? 'active' : ''}`} onClick={() => handleClick('photo3')}>
                <img src={audiophoto} alt="Empty" />
                <div className="text">{t("audio_testimony_ryan_title")}</div>
            </div>

            <div className={`rectangle ${displayedActive === 'photo4' ? 'active' : ''}`} onClick={() => handleClick('photo4')}>
                <img src={audiophoto} alt="Empty" />
                <div className="text">{t("audio_testimony_april_title")}</div>
            </div>

            <div className={`rectangle ${displayedActive === 'photo5' ? 'active' : ''}`} onClick={() => handleClick('photo5')}>
                <img src={audiophoto} alt="Empty" />
                <div className="text">{t("audio_testimony_evelyn_title")}</div>
            </div>

        </div >
    );
};

export default PhotoGallery;